// Construtor de configuração para os tópicos do dashboard

const topicConfigs = {

  /**************************************************************************/
  feedbackempresas: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para feedbackempresas');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.feedbackempresas) {
      throw new Error('NLS inválido: topicConfigs.feedbackempresas não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.feedbackempresas;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa', 'categoria', 'todasempresas', 'todascategorias'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      RPP: 50,
      tipo: "redes",
      idiomaId: sistema.idiomaIdValue || 1,
      pageNumber: 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.filters.empresa && layoutState.filters.empresa.empresaId) {
      params.empresaId = layoutState.filters.empresa.empresaId;
    }
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona categoriaId apenas se existir no layoutState
    if (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.id) {
      params.categoriaId = layoutState.filters.categoria.id;
    }
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: (layoutState && layoutState.filters.empresa && layoutState.filters.empresa.nomeEmpresa) 
        ? layoutState.filters.empresa.nomeEmpresa 
        : topicNls.todasempresas
    });
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Categoria - usa "Todas as categorias" se não houver categoria selecionada
    Filtros.push({
      nomedofiltro: topicNls.categoria,
      valordofiltro: (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.descricao)
        ? layoutState.filters.categoria.descricao
        : topicNls.todascategorias
    });

    Filtros.push({
      nomedofiltro: topicNls.maxfeedbacks50,
      valordofiltro: "50"
    });
    
    const config = {
      nls: {
        post: topicNls.post || "POST",
        empresa: topicNls.empresa,
        comentario: topicNls.comentario || "FEEDBACK",
        redessocias: topicNls.redessocias || "REDES SOCIAIS",
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'feedbackempresas')?.label) || "Feedback por empresa",
      scope: {
        periodo: {
          fim: periodo.fim || "2025-12-31",
          ini: periodo.ini || "2025-01-01"
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "feedbackempresas"
    };
    
    console.log('✅ Config construído:', config);
    return config;
  },

  // ✅ NOVO TÓPICO: feedbackestabelecimentos
  /**************************************************************************/
  feedbackestabelecimentos: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para feedbackestabelecimentos');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.feedbackestabelecimentos) {
      throw new Error('NLS inválido: topicConfigs.feedbackestabelecimentos não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.feedbackestabelecimentos;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['estabelecimento', 'categoria', 'todosestabelecimentos', 'todascategorias'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente
    const params = {
      RPP: 50,
      tipo: "lojas",
      idiomaId: sistema.idiomaIdValue || 1,
      pageNumber: 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.filters.empresa && layoutState.filters.empresa.empresaId) {
      params.empresaId = layoutState.filters.empresa.empresaId;
    }
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona categoriaId apenas se existir no layoutState
    if (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.id) {
      params.categoriaId = layoutState.filters.categoria.id;
    }
    
    // Constrói Filtros dinamicamente
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: (layoutState && layoutState.filters.empresa && layoutState.filters.empresa.nomeEmpresa) 
        ? layoutState.filters.empresa.nomeEmpresa 
        : topicNls.todasempresas
    });
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Categoria - usa "Todas as categorias" se não houver categoria selecionada
    Filtros.push({
      nomedofiltro: topicNls.categoria,
      valordofiltro: (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.descricao)
        ? layoutState.filters.categoria.descricao
        : topicNls.todascategorias
    });

    Filtros.push({
      nomedofiltro: topicNls.maxfeedbacks50,
      valordofiltro: "50"
    });

    
    const config = {
      nls: {
        estabelecimento: topicNls.estabelecimento,
        comentario: topicNls.comentario || "FEEDBACK",
        canal: topicNls.canal || "CHANNEL",
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'feedbackestabelecimentos')?.label) || "Feedback por estabelecimento",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "feedbackestabelecimentos"
    };
    
    console.log('✅ Config feedbackestabelecimentos construído:', config);
    return config;
  },

  /**************************************************************************/
  feedbackprodutos: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para feedbackprodutos');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.feedbackprodutos) {
      throw new Error('NLS inválido: topicConfigs.feedbackprodutos não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.feedbackprodutos;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['produto', 'categoria', 'todasempresas', 'todascategorias'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente
    const params = {
      RPP: 50,
      tipo: "produtos",
      idiomaId: sistema.idiomaIdValue || 1,
      pageNumber: 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.filters.empresa && layoutState.filters.empresa.empresaId) {
      params.empresaId = layoutState.filters.empresa.empresaId;
    }
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona categoriaId apenas se existir no layoutState
    if (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.id) {
      params.categoriaId = layoutState.filters.categoria.id;
    }
    
    // Constrói Filtros dinamicamente
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: (layoutState && layoutState.filters.empresa && layoutState.filters.empresa.nomeEmpresa) 
        ? layoutState.filters.empresa.nomeEmpresa 
        : topicNls.todasempresas
    });
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Categoria - usa "Todas as categorias" se não houver categoria selecionada
    Filtros.push({
      nomedofiltro: topicNls.categoria,
      valordofiltro: (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.descricao)
        ? layoutState.filters.categoria.descricao
        : topicNls.todascategorias
    });

    Filtros.push({
      nomedofiltro: topicNls.maxfeedbacks50,
      valordofiltro: "50"
    });
    
    
    const config = {
      nls: {
        produto: topicNls.produto,
        comentario: topicNls.comentario || "FEEDBACK",
        canal: topicNls.canal || "CHANNEL",
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'feedbackprodutos')?.label) || "Feedback de produtos",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "feedbackprodutos"
    };
    
    console.log('✅ Config feedbackprodutos construído:', config);
    return config;
  },

  /**************************************************************************/
  assuntoempresas: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para assuntoempresas');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.assuntoempresas) {
      throw new Error('NLS inválido: topicConfigs.assuntoempresas não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.assuntoempresas;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['assunto', 'empresas', 'categoria', 'todascategorias'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente
    const params = {
      idiomaId: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona categoriaId apenas se existir no layoutState
    if (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.id) {
      params.categoriaId = layoutState.filters.categoria.id;
    }
    
    // Constrói Filtros dinamicamente
    const Filtros = [];
    
    // Filtro Assunto
    /*
    Filtros.push({
      nomedofiltro: topicNls.assunto,
      valordofiltro: topicNls.empresas
    });
    */
   
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Categoria - usa "Todas as categorias" se não houver categoria selecionada
    Filtros.push({
      nomedofiltro: topicNls.categoria,
      valordofiltro: (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.descricao)
        ? layoutState.filters.categoria.descricao
        : topicNls.todascategorias
    });
    
    const config = {
      nls: {
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'assuntoempresas')?.label) || "Assunto empresas",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id,
        sobreAssunto: "empresas"
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "assuntoempresas"
    };
    
    console.log('✅ Config assuntoempresas construído:', config);
    return config;
  },

  /**************************************************************************/
  assuntoprodutos: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para assuntoprodutos');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.assuntoprodutos) {
      throw new Error('NLS inválido: topicConfigs.assuntoprodutos não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.assuntoprodutos;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['assunto', 'produtos', 'categoria', 'todascategorias'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente
    const params = {
      idiomaId: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona categoriaId apenas se existir no layoutState
    if (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.id) {
      params.categoriaId = layoutState.filters.categoria.id;
    }

    if (layoutState && layoutState.grupo && layoutState.grupo.nomeGrupoProduto) {
      params.grupo = layoutState.grupo.nomeGrupoProduto;
    }
    
    // Constrói Filtros dinamicamente
    const Filtros = [];
    
    // Filtro Grupo
    Filtros.push({
      nomedofiltro: topicNls.grupo,
      valordofiltro: params.grupo
    });
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Categoria - usa "Todas as categorias" se não houver categoria selecionada
    Filtros.push({
      nomedofiltro: topicNls.categoria,
      valordofiltro: (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.descricao)
        ? layoutState.filters.categoria.descricao
        : topicNls.todascategorias
    });
    
    const config = {
      nls: {
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'assuntoprodutos')?.label) || "Assunto produtos",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id,
        sobreAssunto: "produtos"
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "assuntoprodutos"
    };
    
    console.log('✅ Config assuntoprodutos construído:', config);
    return config;
  },

  /**************************************************************************/
  assuntoestabelecimentos: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para assuntoestabelecimentos');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.assuntoestabelecimentos) {
      throw new Error('NLS inválido: topicConfigs.assuntoestabelecimentos não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.assuntoestabelecimentos;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['assunto', 'estabelecimentos', 'categoria', 'todascategorias'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente
    const params = {
      idiomaId: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona categoriaId apenas se existir no layoutState
    if (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.id) {
      params.categoriaId = layoutState.filters.categoria.id;
    }

    if (layoutState && layoutState.grupo && layoutState.grupo.nomeGrupoEstabelecimento) {
      params.grupo = layoutState.grupo.nomeGrupoEstabelecimento;
    }
    
    // Constrói Filtros dinamicamente
    const Filtros = [];
    

// Filtro Grupo
    Filtros.push({
      nomedofiltro: topicNls.grupo,
      valordofiltro: params.grupo
    });

    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Categoria - usa "Todas as categorias" se não houver categoria selecionada
    Filtros.push({
      nomedofiltro: topicNls.categoria,
      valordofiltro: (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.descricao)
        ? layoutState.filters.categoria.descricao
        : topicNls.todascategorias
    });
    
    const config = {
      nls: {
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'assuntoestabelecimentos')?.label) || "Assunto estabelecimentos",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id,
        sobreAssunto: "estabelecimentos"
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "assuntoestabelecimentos"
    };
    
    console.log('✅ Config assuntoestabelecimentos construído:', config);
    return config;
  },

  /**************************************************************************/
  swot: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para swot');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.assuntoestabelecimentos) {
      throw new Error('NLS inválido: topicConfigs.swot não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.swot;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['forca', 'fraqueza', 'ameaca', 'oportunidade', 'preco', 'produto', 'atendimento', 'estabelecimento', 'satisfacaogeral', 'insatisfacaogeral', 'empresa', 'grupo'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente
    const params = {
      idiomaId: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona categoriaId apenas se existir no layoutState
    let nomeempresa = "";
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
      nomeempresa = layoutState.empresa.nomeEmpresa;
    }

    let sobresegmento = "servicos"
    let nomegrupo = "";
    //Antes precisa checar se o projeto é de estabelecimento ou grupo
    if (layoutState && layoutState.projeto && layoutState.projeto.temMenuEstabelecimento) {
        if (layoutState.grupo && layoutState.grupo.idGrupoEstabelecimento) {
          params.grupoLojaId = layoutState.grupo.idGrupoEstabelecimento;
          sobresegmento = "estabelecimentos"
          nomegrupo = layoutState.grupo.name
        } 
    }

    if (layoutState && layoutState.projeto && layoutState.projeto.temMenuProduto) {
        if (layoutState.grupo && layoutState.grupo.idGrupoProduto) {
          params.grupoProdutoId = layoutState.grupo.idGrupoProduto;
          sobresegmento = "produtos"
          nomegrupo = layoutState.grupo.name
        } 
    }

    
    
    // Constrói Filtros dinamicamente
    const Filtros = [];
    
    // Filtro Assunto
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: nomeempresa
    });
    
  
    if(nomegrupo !== "")
      Filtros.push({
        nomedofiltro: topicNls.grupo,
        valordofiltro: nomegrupo
      });
    
    const config = {
      nls: {
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data",
        forca: topicNls.forca || "Strength",
        fraqueza: topicNls.fraqueza || "Weakness",
        ameaca: topicNls.ameaca || "Threat",
        oportunidade: topicNls.oportunidade || "Opportunity",
        preco: topicNls.preco || "Price",
        produto: topicNls.produto || "Product",
        atendimento: topicNls.atendimento || "Service",
        estabelecimento: topicNls.estabelecimento || "Establishment",
        loja: topicNls.estabelecimento || "Establishment",
        satisfacaogeral: topicNls.satisfacaogeral || "Overall Satisfaction",
        insatisfacaogeral: topicNls.insatisfacaogeral || "Overall Dissatisfaction",
        indicadores: topicNls.indicadores || "Main Topics",
                
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'swot')?.label) || "SWOT",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id,
        sobreSegmento: sobresegmento
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "swot"
    };
    
    console.log('✅ Config swot construído:', config);
    return config;
  },


  /**************************************************************************/
  plano7dias: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para plano7dias');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.assuntoestabelecimentos) {
      throw new Error('NLS inválido: topicConfigs.plano7dias não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;

    const planoParams = state.plano7dias || {};
    console.log('📋 Parâmetros do plano7dias recebidos:', planoParams);
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.plano7dias;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['resumo', 'listaplanos'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente
    const params = {
      IdiomaIdUser: sistema.idiomaIdValue || 1
    };

    if (planoParams.idPlanejamento) {
      params.idPlanejamento = planoParams.idPlanejamento;
      console.log('🎯 idPlanejamento adicionado aos params:', planoParams.idPlanejamento);
    }
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona categoriaId apenas se existir no layoutState
    let nomeempresa = "";
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
      nomeempresa = layoutState.empresa.nomeEmpresa;
    }

    params.framework = "YT7dias";

    // Constrói Filtros dinamicamente
    const Filtros = [];
    
    // Filtro Assunto
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: nomeempresa
    });
    
    if (planoParams.nome) {
      Filtros.push({
        nomedofiltro: topicNls.periodo || "Período", // ✅ usa topicNls.periodo
        valordofiltro: planoParams.nome
      });
      console.log('📝 Nome/Período adicionado aos filtros:', planoParams.nome);
    }
    
    const config = {
      nls: {
        resumo: topicNls.resumo || "No data",
        listaplanos: topicNls.listaplanos || "Strength",
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data",
                
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'plano7dias')?.label) || "Plano semanal",
      scope: {       
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "plano7dias"
    };
    
    console.log('✅ Config plano7dias construído:', config);
    return config;
  },

   /**************************************************************************/
   plano30dias: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para plano30dias');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.plano30dias) {
      throw new Error('NLS inválido: topicConfigs.plano30dias não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // ✅ NOVO: Checar se temos parâmetros do plano30dias
    const planoParams = state.plano30dias || {};
    console.log('📋 Parâmetros do plano30dias recebidos:', planoParams);
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.plano30dias;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['resumo', 'listaplanos'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente
    const params = {
      IdiomaIdUser: sistema.idiomaIdValue || 1
    };
    
    // ✅ NOVO: Adicionar idPlanejamento se existir
    if (planoParams.idPlanejamento) {
      params.idPlanejamento = planoParams.idPlanejamento;
      console.log('🎯 idPlanejamento adicionado aos params:', planoParams.idPlanejamento);
    }
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    let nomeempresa = "";
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
      nomeempresa = layoutState.empresa.nomeEmpresa;
    }

    params.framework = "YT30dias";

    // Constrói Filtros dinamicamente
    const Filtros = [];
    
    // Filtro Empresa
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: nomeempresa
    });
    
    // ✅ NOVO: Adicionar filtro com nome/periodo se existir
    if (planoParams.nome) {
      Filtros.push({
        nomedofiltro: topicNls.periodo || "Período",
        valordofiltro: planoParams.nome
      });
      console.log('📝 Nome/Período adicionado aos filtros:', planoParams.nome);
    }
    
    const config = {
      nls: {
        resumo: topicNls.resumo || "No data",
        listaplanos: topicNls.listaplanos || "Strength",
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data",
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'plano30dias')?.label) || "Plano 30 dias",
      scope: {       
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "plano30dias"
    };
    
    console.log('✅ Config plano30dias construído:', config);
    return config;
  },

  /**************************************************************************/
  csatredes: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para csatredes');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.csatredes) {
      throw new Error('NLS inválido: topicConfigs.csatredes não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.csatredes;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idiomaId: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'csatredes')?.label) || "Csat Redes",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "csatredes"
    };
    
    console.log('✅ Config construído:', config);
    return config;
  },


  /**************************************************************************/
  /* NPSREDES */
  npsredes: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para npsredes');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.npsind) {
      throw new Error('NLS inválido: topicConfigs.npsredes não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.npsind;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idiomaId: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'npsredes')?.label) || "Nps Redes",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "npsredes"
    };
    
    console.log('✅ Config construído:', config);
    return config;
  },

  /**************************************************************************/
  csatconcorrentesredes: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para csatconcorrentesredes');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.csatconcorrentesredes) {
      throw new Error('NLS inválido: topicConfigs.csatconcorrentesredes não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.csatconcorrentesredes;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idiomaId: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'csatconcorrentesredes')?.label) || "Csat Concorrentes Redes",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "csatconcorrentesredes"
    };
    
    console.log('✅ Config construído:', config);
    return config;
  },

  /**************************************************************************/
  npsconcorrentesredes: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para npsconcorrentesredes');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.npsconcorrentesredes) {
      throw new Error('NLS inválido: topicConfigs.npsconcorrentesredes não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.npsconcorrentesredes;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idiomaId: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'npsconcorrentesredes')?.label) || "Nps Concorrentes Redes",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "npsconcorrentesredes"
    };
    
    console.log('✅ Config construído:', config);
    return config;
  },

  /**************************************************************************/
  indicadoresredes: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para indicadoresredes');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.indicadoresredes) {
      throw new Error('NLS inválido: topicConfigs.indicadoresredes não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.indicadoresredes;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa', 'categoria'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente
    const params = {
      idiomaId: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona categoriaId apenas se existir no layoutState
    if (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.id) {
      params.categoriaId = layoutState.filters.categoria.id;
    }

    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // Constrói Filtros dinamicamente
    const Filtros = [];
    
    // Filtro Assunto
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa
    });
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Categoria - usa "Todas as categorias" se não houver categoria selecionada
    Filtros.push({
      nomedofiltro: topicNls.categoria,
      valordofiltro: (layoutState && layoutState.filters.categoria && layoutState.filters.categoria.descricao)
        ? layoutState.filters.categoria.descricao
        : topicNls.todascategorias
    });
    
    const config = {
      nls: {
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'indicadoresredes')?.label) || "Indicadores Redes",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id      
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "indicadoresredes"
    };
    
    console.log('✅ Config indicadoresredes construído:', config);
    return config;
  },

  /**************************************************************************/
  csatcliente: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para csatcliente');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.csatcliente) {
      throw new Error('NLS inválido: topicConfigs.csatcliente não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.csatcliente;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'csatcliente')?.label) || "Csat Empresa",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "csatcliente"
    };
    
    console.log('✅ Config construído:', config);
    return config;
  },

  /**************************************************************************/
  npscliente: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para npscliente');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.npscliente) {
      throw new Error('NLS inválido: topicConfigs.npscliente não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.npscliente;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'npscliente')?.label) || "Nps Empresa",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "npscliente"
    };
    
    console.log('✅ Config construído:', config);
    return config;
  },

  /**************************************************************************/
  csatconcorrentes: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para csatconcorrentes');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.csatconcorrentes) {
      throw new Error('NLS inválido: topicConfigs.csatconcorrentes não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.csatconcorrentes;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'csatconcorrentes')?.label) || "Csat Concorrentes",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "csatconcorrentes"
    };
    
    console.log('✅ Config construído:', config);
    return config;
  },

  /**************************************************************************/
  npsconcorrentes: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para npsconcorrentes');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.npsconcorrentes) {
      throw new Error('NLS inválido: topicConfigs.npsconcorrentes não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.npsconcorrentes;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data"
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'npsconcorrentes')?.label) || "Nps Concorrentes",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "npsconcorrentes"
    };
    
    console.log('✅ Config npsconcorrentes construído:', config);
    return config;
  },

  /**************************************************************************/
  csatestabelecimento: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para csatestabelecimento');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.csatestabelecimento) {
      throw new Error('NLS inválido: topicConfigs.csatestabelecimento não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.csatestabelecimento;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data",
        media: topicNls.media,
        desvio: topicNls.desvio,
        atual: topicNls.atual,
        anterior: topicNls.anterior
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'csatestabelecimento')?.label) || "Csat estabelecimento",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "csatestabelecimento"
    };
    
    console.log('✅ Config csatestabelecimento construído:', config);
    return config;
  },

  /**************************************************************************/
  npsestabelecimento: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para npsestabelecimento');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.npsestabelecimento) {
      throw new Error('NLS inválido: topicConfigs.npsestabelecimento não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.npsestabelecimento;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data",
        media: topicNls.media,
        desvio: topicNls.desvio,
        atual: topicNls.atual,
        anterior: topicNls.anterior
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'npsestabelecimento')?.label) || "Nps estabelecimento",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "npsestabelecimento"
    };
    
    console.log('✅ Config npsestabelecimento construído:', config);
    return config;
  },

  /**************************************************************************/
  csatconcorrentesestabelecimento: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para csatconcorrentesestabelecimento');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.csatconcorrentesestabelecimento) {
      throw new Error('NLS inválido: topicConfigs.csatconcorrentesestabelecimento não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.csatconcorrentesestabelecimento;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['grupo'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    
    if (layoutState && layoutState.grupo && layoutState.grupo.nomeGrupoEstabelecimento) {
      params.Grupo = layoutState.grupo.nomeGrupoEstabelecimento;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.grupo,
      valordofiltro: layoutState.grupo.nomeGrupoEstabelecimento 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data",
        atual: topicNls.atual,
        anterior: topicNls.anterior,
        media: topicNls.media,
        desvio: topicNls.desvio
        
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'csatconcorrentesestabelecimento')?.label) || "Csat concorrentes estabelecimento",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "csatconcorrentesestabelecimento"
    };
    
    console.log('✅ Config csatconcorrentesestabelecimento construído:', config);
    return config;
  },

  /**************************************************************************/
  npsconcorrentesestabelecimento: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para npsconcorrentesestabelecimento');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.npsconcorrentesestabelecimento) {
      throw new Error('NLS inválido: topicConfigs.npsconcorrentesestabelecimento não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.npsconcorrentesestabelecimento;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['grupo'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    
    if (layoutState && layoutState.grupo && layoutState.grupo.nomeGrupoEstabelecimento) {
      params.Grupo = layoutState.grupo.nomeGrupoEstabelecimento;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.grupo,
      valordofiltro: layoutState.grupo.nomeGrupoEstabelecimento 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data",
        atual: topicNls.atual,
        anterior: topicNls.anterior,
        media: topicNls.media,
        desvio: topicNls.desvio
        
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'npsconcorrentesestabelecimento')?.label) || "Nps concorrentes estabelecimento",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "npsconcorrentesestabelecimento"
    };
    
    console.log('✅ Config npsconcorrentesestabelecimento construído:', config);
    return config;
  },

  /**************************************************************************/
  csatclienteprodutos: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para csatclienteprodutos');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.csatclienteprodutos) {
      throw new Error('NLS inválido: topicConfigs.csatclienteprodutos não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.csatclienteprodutos;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data",
        media: topicNls.media,
        desvio: topicNls.desvio,
        atual: topicNls.atual,
        anterior: topicNls.anterior
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'csatclienteprodutos')?.label) || "Csat produtos",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "csatclienteprodutos"
    };
    
    console.log('✅ Config csatclienteprodutos construído:', config);
    return config;
  },

  /**************************************************************************/
  npsclienteprodutos: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para npsclienteprodutos');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.npsclienteprodutos) {
      throw new Error('NLS inválido: topicConfigs.npsclienteprodutos não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.npsclienteprodutos;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['empresa'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Adiciona empresaId apenas se existir no layoutState
    if (layoutState && layoutState.empresa && layoutState.empresa.empresaId) {
      params.empresaId = layoutState.empresa.empresaId;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.empresa,
      valordofiltro: layoutState.empresa.nomeEmpresa 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data",
        media: topicNls.media,
        desvio: topicNls.desvio,
        atual: topicNls.atual,
        anterior: topicNls.anterior
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'npsclienteprodutos')?.label) || "Nps produtos",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "npsclienteprodutos"
    };
    
    console.log('✅ Config npsclienteprodutos construído:', config);
    return config;
  },

  /**************************************************************************/
  csatconcorrentesprodutos: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para csatconcorrentesprodutos');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.csatconcorrentesprodutos) {
      throw new Error('NLS inválido: topicConfigs.csatconcorrentesprodutos não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.csatconcorrentesprodutos;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['grupo'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    
    if (layoutState && layoutState.grupo && layoutState.grupo.nomeGrupoProduto) {
      params.Grupo = layoutState.grupo.nomeGrupoProduto;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.grupo,
      valordofiltro: layoutState.grupo.nomeGrupoProduto 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data",
        atual: topicNls.atual,
        anterior: topicNls.anterior,
        media: topicNls.media,
        desvio: topicNls.desvio
        
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'csatconcorrentesprodutos')?.label) || "Csat concorrentes produtos",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "csatconcorrentesprodutos"
    };
    
    console.log('✅ Config csatconcorrentesprodutos construído:', config);
    return config;
  },

  /**************************************************************************/
  npsconcorrentesprodutos: (state, nls, layoutState, projeto, sistema, ordinal) => {
    console.log('🔄 Construindo config para npsconcorrentesprodutos');
    
    // ✅ VALIDAÇÕES DE SEGURANÇA
    if (!state || !state.scope || !state.scope.periodo) {
      throw new Error('Estado inválido: periodo não encontrado');
    }
    
    if (!nls || !nls.topicConfigs || !nls.topicConfigs.npsconcorrentesprodutos) {
      throw new Error('NLS inválido: topicConfigs.npsconcorrentesprodutos não encontrado');
    }
    
    if (!projeto || !projeto.id) {
      throw new Error('Projeto inválido: id não encontrado');
    }
    
    const { periodo } = state.scope;
    
    // Pega os NLS específicos deste tópico
    const topicNls = nls.topicConfigs.npsconcorrentesprodutos;
    
    // ✅ VALIDA NLS OBRIGATÓRIOS
    const nlsObrigatorios = ['grupo'];
    for (const nlsKey of nlsObrigatorios) {
      if (!topicNls[nlsKey]) {
        throw new Error(`NLS obrigatório não encontrado: ${nlsKey}`);
      }
    }
    
    // Constrói params dinamicamente - apenas inclui os que existem
    const params = {
      idioma: sistema.idiomaIdValue || 1
    };
    
    
    if (layoutState && layoutState.grupo && layoutState.grupo.nomeGrupoProduto) {
      params.Grupo = layoutState.grupo.nomeGrupoProduto;
    }
    
    // DESABILITAMOS COMPARAÇÃO COM MÊS ANTERIOR
    // PRECISARIA AJUSTAR:
    // 1. EM CRIAR.JS PRECISA VERIFICAR SE É CICLO
    // 2. SE FOR, PRECISA VER SE COMPARACAO É VERDADEIRO
    // 3. SE FOR PRECISA AJUSTAR O PARÂMETRO INTERVALO
    //ATUALMENTE SÓ PASSO INTERVALO COMO DATAINICIAL DATAFINAL
    params.comparacao = "false";
    
    // Constrói Filtros dinamicamente com valores padrão quando vazios
    const Filtros = [];
    
    // ✅ SUBSTITUIÇÃO: filtersProvisorio → layoutState
    // Filtro Empresa - usa "Todas as empresas" se não houver empresa selecionada
    Filtros.push({
      nomedofiltro: topicNls.grupo,
      valordofiltro: layoutState.grupo.nomeGrupoProduto 
    });
    
    const config = {
      nls: {
        analise: topicNls.analise,
        dadonaodisponivel: topicNls.dadonaodisponivel,
        semdadosparaexibir: topicNls.semdadosparaexibir || "No data",
        atual: topicNls.atual,
        anterior: topicNls.anterior,
        media: topicNls.media,
        desvio: topicNls.desvio
        
      },
      label: (nls.topicos && nls.topicos.find(t => t.key === 'npsconcorrentesprodutos')?.label) || "Nps concorrentes produtos",
      scope: {
        periodo: {
          fim: periodo.fim,
          ini: periodo.ini
        },
        projetoId: projeto.id
      },
      params: params,
      Filtros: Filtros,
      ordinal: ordinal,
      topicKey: "npsconcorrentesprodutos"
    };
    
    console.log('✅ Config npsconcorrentesprodutos construído:', config);
    return config;
  }

  

};

// Função principal que constrói o config completo
export const buildConfig = (selectedTopics, state, nls, layoutState, projeto, sistema) => {
  console.log('🏗️ INICIANDO buildConfig');
  console.log('- selectedTopics:', selectedTopics);
  console.log('- state:', state);
  console.log('- nls:', nls);
  console.log('- layoutState:', layoutState);
  console.log('- projeto:', projeto);
  console.log('- sistema:', sistema);
  
  // ✅ VALIDAÇÕES
  if (!selectedTopics || !Array.isArray(selectedTopics)) {
    throw new Error('selectedTopics deve ser um array');
  }
  
  if (!state) {
    throw new Error('state é obrigatório');
  }
  
  if (!nls) {
    throw new Error('nls é obrigatório');
  }
  
  if (!layoutState) {
    throw new Error('layoutState é obrigatório');
  }
  
  if (!projeto) {
    throw new Error('projeto é obrigatório');
  }
  
  if (!sistema) {
    throw new Error('sistema é obrigatório');
  }

  const components = selectedTopics
    .map((topicKey, index) => {
      console.log(`📦 Processando tópico ${index + 1}: ${topicKey}`);
      const builder = topicConfigs[topicKey];
      
      if (!builder) {
        console.warn(`⚠️ Builder não encontrado para tópico: ${topicKey}`);
        return null;
      }
      
      try {
        const component = builder(state, nls, layoutState, projeto, sistema, index + 1);
        console.log(`✅ Tópico ${topicKey} processado com sucesso`);
        return component;
      } catch (error) {
        console.error(`❌ Erro ao processar tópico ${topicKey}:`, error);
        return null;
      }
    })
    .filter(component => component !== null);

  const result = { components };
  console.log('🏁 buildConfig finalizado:', result);
  return result;
};